import { createSlice } from '@reduxjs/toolkit'

export const nowSlice = createSlice({
  name: 'now',
  initialState: null,
  reducers: {
    setNow: (state, action) => action.payload,
  },
})

export const selectNow = (state) => state.now

export const { setNow } = nowSlice.actions

export default nowSlice.reducer
